/**
 * Service panel
 * @dependencies jQuery
 * @dependencies Foundation
 */

import $ from 'jquery';

(function ($, Drupal, once) {
  Drupal.behaviors.servicePanel = {
    attach: function (context) {
      $(once('servicePanel', '#servicePanel', context)).each(function (i, e) {
        const servicePanel = document.getElementById('servicePanel');
        $('.main').on('click', '.js-service-panel', function (e) {
          e.preventDefault();
          servicePanel.classList.add('js-ajax-pending');
          $.ajax({
            url: $(this).data('url'),
            success: function (result) {
              const serviceContent = $('.service', result);
              $(servicePanel).html(serviceContent);
              setTimeout(() => {
                Drupal.drimage.init(servicePanel);
                servicePanel.classList.remove('js-ajax-pending');
              }, 1);
            },
            error: function (result) {
              servicePanel.innerHTML = 'Error loading content. Please close and retry.';
              servicePanel.classList.remove('js-ajax-pending');
            },
          });
        });
      });
    },
  };
})(jQuery, Drupal, once);
